import { writable } from 'svelte/store';
import { subscribe } from 'svelte/internal';
import localMachines from '../localMachines.js'
// const store = writable(flattenMachines([...localMachines]));
const store = writable(flattenMachines([...localMachines]));

//set
// subscribe
// update

function flattenMachines(data) {
    return data.map((item) => {
        let image = item.image.url;
        console.log('item', item);

        return { ...item, image }
    })
}

export default store;